import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AButton from '../../../../common/form-fields-mui/AButton';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { DetailsCell } from '../StudentDetails';
import { fetchAllPostPromisedData, fetchAllPromisedData } from '../../../../common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from '../../../../common/constant';
import AAutoComplete from '../../../../common/form-fields-mui/AAutoComplete';
import { adjustmentFlagOptions } from '../../../../edpOps/studentDetails/results/utils';
import { successToast } from '../../../../common/utils/methods/toasterFunctions/function';
import ALoader from '../../../../common/a-loader';
import { getCourseDetailsByCourseId } from '../../../concessionApproval/approvalBranch';

const testDetailsMapping = [
    { label: 'Name', keyName: 'examTimeCode' },
    { label: 'Course Name', keyName: 'courseName' },
    { label: 'Test Date', keyName: 'examDate' },
    { label: 'Campus', keyName: 'businessArea' },
    { label: 'Roll no.', keyName: 'rollNumber' },
    { label: 'Test Code', keyName: 'examTimeCode' },
]

const resultDetailsMapping = [
    { label: 'Total Marks', keyName: 'aesTotalMarks' },
    { label: 'Percentage', keyName: 'percentage' },
    { label: 'Class Rank', keyName: 'classRank' },
    { label: 'State Rank', keyName: 'aesStateRank' },
    { label: 'Percentile', keyName: 'percentile' },
    { label: 'All India Rank', keyName: 'aesAllIndRank' },
]

const TestResultDialog = ({ testResultDialogInfo, setTestResultDialogInfo, fetchExamChargesData }) => {

    const [loading, setLoading] = useState(false);
    const [resultInfo, setResultInfo] = useState({});
    const [mode, setMode] = useState('view');
    const [adjustmentFlag, setAdjustmentFlag] = useState(null);
    const [courseName , setCourseName] = useState('');

    const { isOpen, exam } = testResultDialogInfo;
    const examDetails = {...exam , courseName};

    const closeDialog = () => setTestResultDialogInfo({ isOpen: false, exam: {} })


    const getTestResultAndCourseDetails = async () => {
        try {
            setLoading(true);
            const {courseId , rollNumber} = exam;
            const res = await Promise.all([
                getCourseDetailsByCourseId(courseId),
                fetchAllPromisedData(`${endpoint.studentResult.getStudentResultByRollNumber}?rollNumber=${rollNumber}`)
            ])
            const result = res[1]?.[0] ?? {};
            const courseName = res[0]?.courseName;
            setCourseName(courseName);
            setResultInfo(result);
            setAdjustmentFlag(adjustmentFlagOptions?.find(option => option.value === result.adjustmentFlg));

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }


    const updateResult = async () => {
        try {
            setLoading(true);
            const { externalSystemId, examDate, examTimeCode } = resultInfo;
            const req = {
                externalSystemId,
                examDate,
                examTimeCode,
                updatedAdjustmentFlag: adjustmentFlag?.value
            }

            const resp = await fetchAllPostPromisedData(endpoint.studentResult.updateAdjustmentFlag, req, 'put');
            if (resp?.code === 200) {
                successToast('Result updated successfully!!');
                closeDialog();
                fetchExamChargesData();
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        isOpen && getTestResultAndCourseDetails();
    }, [])


    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="md"
        >
            <div className='p-4 test-result-dialog d-flex flex-column justify-content-between'>

                {loading && <ALoader position="fixed" />}

                <div className='d-flex justify-content-between'>
                    <h2>Student test result</h2>
                    <div>
                        <AButton
                            variant='primary_filled'
                            size='xs'
                            className='mr-2'
                            onClick={mode === 'edit' ? updateResult : () => setMode('edit')}
                        >
                            {mode === 'edit' ? 'Save changes' : 'Update'}
                        </AButton>

                        <CrossIcon onClick={closeDialog} />
                    </div>
                </div>


                <h3>Test Details</h3>

                <div className='test-details-container'>
                    {testDetailsMapping?.map(({ label, keyName }) =>
                        <DetailsCell key={label} label={label} value={examDetails[keyName]} />
                    )}
                </div>

                <hr className='w-100' />

                <h3>Result</h3>

                <div className='result-details-container'>
                    {resultDetailsMapping?.map(({ label, keyName }) =>
                        <DetailsCell key={label} label={label} value={resultInfo[keyName]} />
                    )}

                    {
                        mode === 'view'
                            ? <DetailsCell label='AdjustmentFlag' value={resultInfo['adjustmentFlg']} />
                            : <AAutoComplete
                                items={adjustmentFlagOptions}
                                currentValue={adjustmentFlag}
                                handleChange={val => setAdjustmentFlag(val)}
                                label='Adjustment Flag'
                                isMulti={false}
                            />
                    }

                </div>

            </div>

        </Dialog>
    );
}

export default TestResultDialog;